(() => {
  const PAGE_SIZE = 10;

  function visiblePageNumbers(current, total) {
    const wanted = new Set([1, total, current - 1, current, current + 1]);
    return Array.from(wanted)
      .filter((value) => value >= 1 && value <= total)
      .sort((a, b) => a - b);
  }

  function initializeJournal(root) {
    if (!root || root.dataset.mpjReady === 'true') return;
    root.dataset.mpjReady = 'true';

    const entries = Array.from(root.querySelectorAll('[data-mpj-entry]'));
    const search = root.querySelector('[data-mpj-search]');
    const filter = root.querySelector('[data-mpj-filter]');
    const status = root.querySelector('[data-mpj-status]');
    const pagers = Array.from(root.querySelectorAll('[data-mpj-pager]'));
    if (!entries.length || !search || !filter || !status) return;

    let page = 1;

    function matchingEntries() {
      const query = search.value.trim().toLocaleLowerCase();
      const kind = filter.value;
      return entries.filter((entry) => {
        const kindMatches = kind === 'all' || entry.dataset.kind === kind;
        const searchMatches = !query || (entry.dataset.search || '').includes(query);
        return kindMatches && searchMatches;
      });
    }

    function makeButton(label, targetPage, options = {}) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.setAttribute('aria-label', options.ariaLabel || `Journal page ${targetPage}`);
      if (options.current) button.setAttribute('aria-current', 'page');
      if (options.disabled) button.disabled = true;
      button.addEventListener('click', () => {
        page = targetPage;
        render();
        root.querySelector('#mpj-journal-title')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return button;
    }

    function renderPager(container, pageCount) {
      container.replaceChildren();
      if (pageCount <= 1) return;

      container.append(makeButton('Previous', Math.max(1, page - 1), {
        ariaLabel: 'Previous journal page',
        disabled: page === 1
      }));

      const numbers = visiblePageNumbers(page, pageCount);
      numbers.forEach((number, index) => {
        if (index > 0 && number - numbers[index - 1] > 1) {
          const ellipsis = document.createElement('span');
          ellipsis.textContent = '…';
          ellipsis.setAttribute('aria-hidden', 'true');
          container.append(ellipsis);
        }
        container.append(makeButton(String(number), number, { current: number === page }));
      });

      container.append(makeButton('Next', Math.min(pageCount, page + 1), {
        ariaLabel: 'Next journal page',
        disabled: page === pageCount
      }));
    }

    function render() {
      const matches = matchingEntries();
      const pageCount = Math.max(1, Math.ceil(matches.length / PAGE_SIZE));
      page = Math.min(Math.max(page, 1), pageCount);
      const start = (page - 1) * PAGE_SIZE;
      const visible = new Set(matches.slice(start, start + PAGE_SIZE));

      entries.forEach((entry) => {
        entry.hidden = !visible.has(entry);
      });

      if (!matches.length) {
        status.textContent = `No ${root.dataset.caseName || 'case'} journal entries match that search and filter.`;
      } else {
        const first = start + 1;
        const last = Math.min(start + PAGE_SIZE, matches.length);
        status.textContent = `Showing entries ${first}–${last} of ${matches.length} · Page ${page} of ${pageCount}`;
      }

      pagers.forEach((pager) => renderPager(pager, matches.length ? pageCount : 0));
    }

    search.addEventListener('input', () => {
      page = 1;
      render();
    });
    filter.addEventListener('change', () => {
      page = 1;
      render();
    });

    render();
  }

  function initializeAll() {
    document.querySelectorAll('[data-mpj-case]').forEach(initializeJournal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
